var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "50", height: "50", viewBox: "0 0 50 50", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Page 1"
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("circle", { cx: "25", cy: "25", r: "25", fill: "#5B89EE" }),
      React.createElement(
        "g",
        { stroke: "#FFF", strokeWidth: "1.5" },
        React.createElement("path", { d: "M18.611 22.031c0 1.865-1.542 3.375-3.444 3.375-1.904 0-3.445-1.51-3.445-3.375 0-1.864 1.54-3.375 3.445-3.375 1.902 0 3.444 1.51 3.444 3.375zM17.312 30.469H10c0-2.795 2.346-5.063 5.243-5.063 1.737 0 3.276.815 4.23 2.07M38.417 22.031c0 1.865-1.542 3.375-3.445 3.375-1.904 0-3.444-1.51-3.444-3.375 0-1.864 1.54-3.375 3.444-3.375 1.903 0 3.445 1.51 3.445 3.375zM30.667 27.478c1.039-1.255 2.718-2.072 4.615-2.072 3.16 0 5.718 2.267 5.718 5.063h-7.975M29.806 20.766c0 2.563-2.121 4.64-4.736 4.64-2.617 0-4.737-2.077-4.737-4.64 0-2.563 2.12-4.641 4.737-4.641 2.615 0 4.736 2.078 4.736 4.64z" }),
        React.createElement("path", { d: "M32.389 33h-15.5c0-4.194 3.467-7.594 7.75-7.594 4.281 0 7.75 3.4 7.75 7.594z" })
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/assets/icons/team_icon_in_circle.svg